import { render, staticRenderFns } from "./localIncomeTotal.vue?vue&type=template&id=09ae0040"
import script from "./localIncomeTotal.vue?vue&type=script&lang=js"
export * from "./localIncomeTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports